import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button, IconButton, TableCell, TableRow, Tooltip, Typography } from '@mui/material'
import CasinoIcon from '@mui/icons-material/Casino'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import Delete from './Delete'
import { ExportButton } from '../../component/shared/component/ExportButton'
import { exportFileName, getSourceLabel } from '../../utils/luckyDraw'
import { useExportLuckyDraw } from '../../api/lucky-draw'

// Long prize lists would stretch the row; the rest are summarised.
const VISIBLE_PRIZES = 4

const Row = ({ data, sources, refetch }) => {
  const [openDelete, setOpenDelete] = useState(false)
  const { mutateAsync: exportDraw } = useExportLuckyDraw(data.id)

  const shown = data.prizes.slice(0, VISIBLE_PRIZES)
  const hidden = data.prizes.length - shown.length

  return (
    <>
      <TableRow>
        <TableCell>{data.name}</TableCell>
        <TableCell>{getSourceLabel(sources, data.source)}</TableCell>
        <TableCell>{data.maxWinsPerDraw}</TableCell>
        <TableCell>
          {shown.map((prize) => (
            <Typography key={prize.id} variant='body2'>
              {prize.name} — {prize.groupName} — {prize.awarded}/{prize.quantity}
            </Typography>
          ))}
          {hidden > 0 && (
            <Typography variant='caption' color='text.secondary'>
              +{hidden} more
            </Typography>
          )}
        </TableCell>
        <TableCell>
          <Button
            variant='contained'
            size='small'
            startIcon={<CasinoIcon />}
            component={Link}
            to={`/lucky-draw/${data.id}/roll`}
          >
            Draw
          </Button>
        </TableCell>
        <TableCell>
          <ExportButton
            exportFn={exportDraw}
            filename={exportFileName(data.name)}
            label='Export'
            iconOnly
            color='primary'
            size='small'
          />
        </TableCell>
        <TableCell>
          <Tooltip title='Edit'>
            <IconButton
              color='primary'
              component={Link}
              to={`/lucky-draw/${data.id}/edit`}
              size='small'
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
        <TableCell>
          <Tooltip title='Delete'>
            <IconButton color='error' onClick={() => setOpenDelete(true)} size='small'>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
      <Delete
        data={data}
        openDelete={openDelete}
        onClose={() => setOpenDelete(false)}
        refetch={refetch}
      />
    </>
  )
}

export default Row
